export const CARRIER_CANCELLATION_REASON_MAPPING_FF = 'carrier_cancellation_reason_mapping';
